import { memo } from "react";

import { Layout } from "./layout";

export type Props = {
	title: string;
	children: React.ReactNode;
};

export const FeatureIslandLayout = memo(({ title, children }: Props) => {
	return (
		<Layout className="grid gap-y-3">
			<h4 className="font-semibold">{title}</h4>

			<Layout className="rounded-lg border border-zinc-100 bg-white p-4 lg:p-12">{children}</Layout>
		</Layout>
	);
});
